export class UnableToCutOverlappingStopVersion extends Error {}
